import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "app/layout/style.scss";
import { DataGrid } from '@mui/x-data-grid';
import useWindowSize from 'app/hooks/useWindowSize';
import { DatePicker } from '@mui/lab';
import TextField from '@mui/material/TextField';
import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import { PopoverCell } from 'app/components/DataGrid/PopoverCell';
import { LoginStatusContext } from 'app/context/LoginStatusContext';
import { getContainerData } from 'app/helpers/containerHelper';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { processDate } from "app/util/dateUtils";
import { favouriteBooking } from 'app/components/Booking/favouriteBooking';
import { CargoMode } from "app/types/enums";
export default function ShipmentSearch() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [_UserSystemKey] = useState(sessionStorage.getItem('_UserSystemKey'));
    const [expanded, setExpanded] = useState([]);
    var defaultFromDate = new Date();
    defaultFromDate.setMonth(defaultFromDate.getMonth() - 1);
    const [fromDate, setFromDate] = useState(defaultFromDate);
    var defaultToDate = new Date();
    defaultToDate.setMonth(defaultToDate.getMonth() + 2);
    const [toDate, setToDate] = useState(defaultToDate);
    const [canSearchBookingFrom, setCanSearchBookingFrom] = useState(true);
    const [canSearchBookingTo, setCanSearchBookingTo] = useState(true);
    const { setIsLoggedIn } = useContext(LoginStatusContext);
    const [selectedSearchType, setSelectedSearchType] = useState('EstimatedArrivalDate');
    const [selectedBookingTypeId, setSelectedBookingTypeId] = useState(18);
    const [selectedCargoMode, setSelectedCargoMode] = useState('All');

    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                    .then(() => setIsLoggedIn(true));

            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    const windowSize = useWindowSize();

    const getShipments = useCallback(async () => {
        setLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_ENDPOINT}/api/shipment/getwebportalsearchdata`;
            const params = {
                fromDate: fromDate,
                toDate: toDate,
                searchType: selectedSearchType,
                bookingTypeId: selectedBookingTypeId,
                cargoMode: selectedCargoMode
            }
            const response = await axios.get(url, { params: params });
            setItems(response.data);
            setLoading(false);
        } catch (error) {
            console.error(`An error occured whilst fetching table data with the error ${error}`);
            setLoading(false);
        }
    }, [fromDate, selectedBookingTypeId, selectedCargoMode, selectedSearchType, toDate])

    useEffect(() => {
        //Async method used to call the Web API and populate the item state with a json object.
        getShipments();
    }, [getShipments]);

    useEffect(() => {
        var fromDate = new Date();
        var toDate = new Date();
        switch (selectedSearchType) {
            case 'EstimatedArrivalDate':
            case 'EstimatedDepartureDate':
                fromDate.setMonth(fromDate.getMonth() - 1);
                setFromDate(fromDate);
                toDate.setMonth(toDate.getMonth() + 2);
                setToDate(toDate);
                break;
            default:
                fromDate.setFullYear(fromDate.getFullYear() - 1);
                setFromDate(fromDate);
                setToDate(new Date());
                break;
        }

    }, [selectedSearchType]);

    const handleCellClick = (param, event) => {
        if (param.field !== 'isFavourite') {
            return window.location.href = '/LeoSeaPortal/bookingdetails?shipmentId=' + param.row.shipmentID + ''
        }
    };

    const fromDateOnChange = (date) => {
        setFromDate(date);
        if (date) {
            if (date.toLocaleDateString('en-GB').length !== 10) {
                setCanSearchBookingFrom(false);
            }
            else if (!isNaN(date.getTime())) {
                setCanSearchBookingFrom(true);
            }
            else {
                setCanSearchBookingFrom(false);
            }
        }
        else {
            setCanSearchBookingFrom(false);
        }
    };

    const toDateOnChange = (date) => {
        setToDate(date);
        if (date) {
            if (date.toLocaleDateString('en-GB').length !== 10) {
                setCanSearchBookingTo(false);
            }
            else if (!isNaN(date.getTime())) {
                setCanSearchBookingTo(true);
            }
            else {
                setCanSearchBookingTo(false);
            }
        }
        else {
            setCanSearchBookingTo(false);
        }
    };

    const fromDateValidation = (error) => {
        if (error) {
            setCanSearchBookingFrom(false);
        }
    };

    const toDateValidation = (error) => {
        if (error) {
            setCanSearchBookingTo(false);
        }
    };

    const searchShipment = () => {
        setLoading(true);
        getShipments();
    };

    const getSeaColumns = () => {
        var userSeaBookingColumnKey = `${sessionStorage.getItem('_UserId')}_SearchSeaBookingColumns`;
        const defaultSeaColumns = [
            {
                field: 'shipmentID',
                headerName: 'shipmentID',
                type: 'number',
                hide: true
            },
            {
                field: 'isFavourite',
                headerName: '',
                type: 'boolean',
                minWidth: 50,
                flex: 1,
                renderCell: (params) => {
                    return favouriteBooking(params.row);
                }
            },
            {
                field: 'shipmentRef',
                headerName: 'Europa Reference',
                minWidth: 150,
                flex: 1
            },
            {
                field: 'purchaseOrderReferenceNo',
                headerName: 'Purchase Order No',
                minWidth: 150,
                flex: 1
            },
            {
                field: 'portOfLoading',
                headerName: 'Port of Loading',
                minWidth: 100,
                flex: 1
            },
            {
                field: 'estimatedDepartureDate',
                headerName: 'ETD',
                minWidth: 100,
                flex: 1,
                renderCell: (params) => {
                    return processDate(params.row.estimatedDepartureDate);
                }
            },
            {
                field: 'portOfDischarge',
                headerName: 'Port of Discharge',
                minWidth: 120,
                flex: 1
            },
            {
                field: 'estimatedArrivalDate',
                headerName: 'ETA',
                minWidth: 100,
                flex: 1,
                renderCell: (params) => {
                    return processDate(params.row.estimatedArrivalDate);
                }
            },
            {
                field: 'europaPredictedArrivalDate',
                headerName: 'Europa Predicted ETA',
                minWidth: 100,
                flex: 1,
                renderCell: (params) => {
                    return processDate(params.row.europaPredictedArrivalDate);
                }
            },
            {
                field: 'vessel',
                headerName: 'Vessel Name',
                minWidth: 120,
                flex: 1
            },
            {
                field: 'carrier',
                headerName: 'Carrier',
                minWidth: 120,
                flex: 1,
                renderCell: (params) => {
                    return params.row.cargoMode === CargoMode.LCL ? params.row.vesselCarrier : params.row.carrier
                }
            },
            {
                field: 'containers',
                headerName: 'Container(s)',
                minWidth: 100,
                flex: 1,
                renderCell: (params) => (
                    <PopoverCell data={params.row.shipmentPackages.map(sp => {
                        return getContainerData(params.row, sp);
                    })
                    } />
                )
            },
            {
                field: 'shipper',
                headerName: 'Shipper',
                minWidth: 200,
                flex: 1
            },
            {
                field: 'consignee',
                headerName: 'Consignee',
                minWidth: 200,
                flex: 1
            },
            {
                field: 'deliveryAddress',
                headerName: 'Delivery Address',
                minWidth: 200,
                flex: 1
            },
            {
                field: 'termType',
                headerName: 'Terms',
                minWidth: 100,
                flex: 1
            }
        ];

        var usersSeaBookingColumns = localStorage.getItem(userSeaBookingColumnKey);
        if (usersSeaBookingColumns) {
            var usersSeaBookingColumns = JSON.parse(usersSeaBookingColumns);

            defaultSeaColumns.map((defaultSeaColumn) => {
                var field = usersSeaBookingColumns.find((usersSeaBookingColumn) => {
                    return usersSeaBookingColumn.field === defaultSeaColumn.field;
                });
                if (field) {
                    defaultSeaColumn.hide = field.hide;
                }
            });

            localStorage.setItem(userSeaBookingColumnKey, JSON.stringify(defaultSeaColumns));

            return defaultSeaColumns;

        }
        else {
            localStorage.setItem(userSeaBookingColumnKey, JSON.stringify(defaultSeaColumns));
            return defaultSeaColumns;
        }
    };

    const getAirColumns = () => {
        var userAirBookingColumnKey = `${sessionStorage.getItem('_UserId')}_SearchAirBookingColumns`;
        const defaultAirColumns = [
            {
                field: 'shipmentID',
                headerName: 'shipmentID',
                type: 'number',
                hide: true
            },
            {
                field: 'isFavourite',
                headerName: '',
                type: 'boolean',
                minWidth: 50,
                flex: 1,
                renderCell: (params) => {
                    return favouriteBooking(params.row);
                }
            },
            {
                field: 'shipmentRef',
                headerName: 'Europa Reference',
                minWidth: 150,
                flex: 1
            },
            {
                field: 'purchaseOrderReferenceNo',
                headerName: 'Purchase Order No',
                minWidth: 150,
                flex: 1
            },
            {
                field: 'shipper',
                headerName: 'Shipper',
                minWidth: 200,
                flex: 1
            },
            {
                field: 'consignee',
                headerName: 'Consignee',
                minWidth: 200,
                flex: 1
            },
            {
                field: 'deliveryAddress',
                headerName: 'Delivery Address',
                minWidth: 200,
                flex: 1
            },
            {
                field: 'airportOfLoading',
                headerName: 'Airport of Loading',
                minWidth: 100,
                flex: 1
            },
            {
                field: 'estimatedDepartureDate',
                headerName: 'ETD',
                minWidth: 100,
                flex: 1,
                renderCell: (params) => {
                    return processDate(params.row.estimatedDepartureDate);
                }
            },
            {
                field: 'airportOfDischarge',
                headerName: 'Airport of Discharge',
                minWidth: 120,
                flex: 1
            },
            {
                field: 'flightNumber',
                headerName: 'Flight Number',
                minWidth: 120,
                flex: 1
            },
            {
                field: 'estimatedArrivalDate',
                headerName: 'ETA',
                minWidth: 100,
                flex: 1,
                renderCell: (params) => {
                    return processDate(params.row.estimatedArrivalDate);
                }
            }
        ];

        var usersAirBookingColumns = localStorage.getItem(userAirBookingColumnKey);
        if (usersAirBookingColumns) {
            var usersAirBookingColumns = JSON.parse(usersAirBookingColumns);

            defaultAirColumns.map((defaultAirColumn) => {
                var field = usersAirBookingColumns.find((usersAirBookingColumn) => {
                    return usersAirBookingColumn.field === defaultAirColumn.field;
                });
                if (field) {
                    defaultAirColumn.hide = field.hide;
                }
            });

            localStorage.setItem(userAirBookingColumnKey, JSON.stringify(defaultAirColumns));

            return defaultAirColumns;

        }
        else {
            localStorage.setItem(userAirBookingColumnKey, JSON.stringify(defaultAirColumns));
            return defaultAirColumns;
        }
    };

    const bookingTypeOnChange = (event) => {

        if (event.target.value) {
            setSelectedBookingTypeId(event.target.value);
        }
    }

    const searchTypeOnChange = (event) => {

        if (event.target.value) {
            setSelectedSearchType(event.target.value);
        }
    }

    const cargoModeOnChange = (event) => {

        if (event.target.value) {
            setSelectedCargoMode(event.target.value);
        }
    }

    //Rendering the Sea Shipment table using the items object passed through by the populate method.
    const renderSeaTable = (items) => {
        if (selectedBookingTypeId === 18) {
            if (items.length > 0) {
                return (
                    <GridItem xs={12}>
                        <div style={{ width: '100%', fontSize: '6px' }}>
                            <DataGrid
                                getRowId={(row) => row.shipmentID}
                                rows={items}
                                pageSize={10}
                                autoHeight={true}
                                onCellClick={handleCellClick}
                                columns={getSeaColumns()}
                                onColumnVisibilityChange={(param) => {
                                    var userSeaBookingColumnKey = `${sessionStorage.getItem('_UserId')}_SearchSeaBookingColumns`;
                                    var userSeaBookingColumns = JSON.parse(localStorage.getItem(userSeaBookingColumnKey));
                                    var updated = userSeaBookingColumns.map((col) =>
                                        col.field === param.field ? { ...col, hide: !param.isVisible } : col);
                                    localStorage.setItem(userSeaBookingColumnKey, JSON.stringify(updated));
                                }}
                                rowHeight={40}
                                sx={{
                                    fontSize: 'small',
                                    "& .MuiDataGrid-row:hover": {
                                        backgroundColor: "#90EE90",
                                        cursor: 'pointer'
                                    }
                                }}
                            />
                        </div>
                    </GridItem>
                );
            } else {
                return (<span>No results found...</span>);
            }
        }
    }

    //Rendering the Air Shipment table using the items object passed through by the populate method.
    const renderAirTable = (items) => {
        if (selectedBookingTypeId === 17) {
            if (items.length > 0) {
                return (
                    <GridItem xs={12}>
                        <div style={{ width: '100%', fontSize: '6px' }}>
                            <DataGrid
                                getRowId={(row) => row.shipmentID}
                                rows={items}
                                pageSize={10}
                                autoHeight={true}
                                onCellClick={handleCellClick}
                                columns={getAirColumns()}
                                onColumnVisibilityChange={(param) => {
                                    var userAirBookingColumnKey = `${sessionStorage.getItem('_UserId')}_SearchAirBookingColumns`;
                                    var userAirBookingColumns = JSON.parse(localStorage.getItem(userAirBookingColumnKey));
                                    var updated = userAirBookingColumns.map((col) =>
                                        col.field === param.field ? { ...col, hide: !param.isVisible } : col);
                                    localStorage.setItem(userAirBookingColumnKey, JSON.stringify(updated));
                                }}
                                rowHeight={40}
                                sx={{
                                    fontSize: 'small',
                                    "& .MuiDataGrid-row:hover": {
                                        backgroundColor: "#90EE90",
                                        cursor: 'pointer'
                                    }
                                }}
                            />
                        </div>
                    </GridItem>
                );
            } else {
                return (<span>No results found...</span>);
            }
        }
    }

    let seaContents = loading && selectedBookingTypeId === 18
        ? <CircularProgress style={{ position: 'relative', left: '50%', color: '#1DB35A' }}></CircularProgress>
        : renderSeaTable(items.webPortalSeaBookings);

    let airContents = loading && selectedBookingTypeId === 17
        ? <CircularProgress style={{ position: 'relative', left: '50%', color: '#1DB35A' }}></CircularProgress>
        : renderAirTable(items.webPortalAirBookings);

    return (
        <div id="ShipmentSearch" style={{ position: 'relative', zIndex: '0' }}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader style={{ backgroundColor: '#1DB35A', color: '#FFF' }}>
                            <h4>Bookings</h4>
                        </CardHeader>
                        <CardBody>
                            <GridItem xs={12} sm={12}>
                                <FormControl style={{ width: 110 }}>
                                    <InputLabel id="bookingtype">Booking Type</InputLabel>
                                    <Select
                                        labelId="bookingtype"
                                        id="bookingtype"
                                        value={selectedBookingTypeId}
                                        label="Booking Type"
                                        size="small"
                                        sx={{ marginRight: 1, marginBottom: 1 }}
                                        onChange={bookingTypeOnChange}>
                                        <MenuItem value={17}>Air</MenuItem>
                                        <MenuItem value={18}>Sea</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl style={{ width: 140 }}>
                                    <InputLabel id="searchType">Search Type</InputLabel>
                                    <Select
                                        labelId="searchType"
                                        id="searchType"
                                        value={selectedSearchType}
                                        label="Search Type"
                                        size="small"
                                        sx={{ marginRight: 1, marginBottom: 1 }}
                                        onChange={searchTypeOnChange}>
                                        <MenuItem value={'DateAdded'}>Added Date</MenuItem>
                                        <MenuItem value={'EstimatedArrivalDate'}>ETA</MenuItem>
                                        <MenuItem value={'EstimatedDepartureDate'}>ETD</MenuItem>
                                        <MenuItem value={'IsFavourite'}>Favourite</MenuItem>
                                    </Select>
                                </FormControl>
                                {selectedBookingTypeId === 18 && (<FormControl style={{ width: 100 }}>
                                    <InputLabel id="cargoMode">Cargo Mode</InputLabel>
                                    <Select
                                        labelId="cargoMode"
                                        id="cargoMode"
                                        value={selectedCargoMode}
                                        label="Cargo Mode"
                                        size="small"
                                        sx={{ marginRight: 1, marginBottom: 1 }}
                                        onChange={cargoModeOnChange}>
                                        <MenuItem value={'All'}>All</MenuItem>
                                        <MenuItem value={'FCL'}>FCL</MenuItem>
                                        <MenuItem value={'LCL'}>LCL</MenuItem>
                                    </Select>
                                </FormControl>)}
                                <DatePicker
                                    id="fromDate"
                                    name="fromDate"
                                    label="From"
                                    value={fromDate}
                                    onError={fromDateValidation}
                                    onChange={fromDateOnChange}
                                    renderInput={(params) => <TextField size="small" required sx={{ marginRight: 1 }} {...params} />}
                                />
                                <DatePicker
                                    id="toDate"
                                    name="toDate"
                                    label="To"
                                    value={toDate}
                                    onError={toDateValidation}
                                    onChange={toDateOnChange}
                                    renderInput={(params) => <TextField size="small" required sx={{ marginBottom: 1, marginRight: 1 }} {...params} />}
                                />
                                <Button
                                    style={{ backgroundColor: '#1DB35A', color: '#FFF', marginTop: 1 }}
                                    disabled={!canSearchBookingFrom || !canSearchBookingTo}
                                    onClick={searchShipment}>
                                    <SearchOutlinedIcon />
                                </Button>
                            </GridItem>
                            {airContents}
                            {seaContents}
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
